import React, { useState, useEffect } from "react";
import ReactModal from "react-modal";
import styles from "./style.module.scss";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import Select from "../../../../components/form/select";

import { updateProgression, getProgressionList } from "../../../../../api";
import toast from "react-hot-toast";
import Modal from "../../../../components/modal";

function EditStatus({ open, onClose, appData, fetchApplication }) {
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [progressionList, setProgressionList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const updateStatus = async () => {
    const payload = {
      editslug: appData?.editslug,
      id: appData?.id,
      progression_id: selectedStatus?.value,
    };
    setIsLoading(true);
    setError("");
    const toastId = toast.loading("Loading...");
    const response = await updateProgression(payload);
    if (response.status) {
      toast.success("Status updated successfully!", { id: toastId });
      fetchApplication();
      onClose();
    } else {
      toast.error("Something went wrong!", { id: toastId });
      setIsLoading(false);
      setError("Something went wrong!");
    }
  };
  useEffect(() => {
    const fetchProgressionList = async () => {
      const response = await getProgressionList();
      setProgressionList(
        response.data.map((item) => ({
          value: item.id,
          label: item.status,
        })),
      );
    };
    fetchProgressionList();
  }, []);
  return (
    <Modal isOpen={open} onClose={onClose} size="sm">
      <div className={styles.container}>
        <h6 className={styles.title}>Edit Status</h6>

        <Select
          options={progressionList}
          label={"Select Status"}
          search={true}
          onChange={(value) => {
            const selectedOption = progressionList.find(
              (opt) => opt.value === value.value,
            );
            setSelectedStatus(selectedOption);
            setError("");
          }}
          value={selectedStatus}
          key={`status-select-${selectedStatus?.value}`}
          id={"status"}
          name={"status"}
        />

        {error && <p className={styles.error}>{error}</p>}

        <div className={styles.footer}>
          <ButtonIcon textColor="#254FE2" onClick={onClose}>
            Cancel
          </ButtonIcon>

          <ButtonIcon
            bgColor={"#4C70EF"}
            textColor="#FFF"
            onClick={updateStatus}
            isLoading={isLoading}
            disabled={error.length > 0 || isLoading}
          >
            Update
          </ButtonIcon>
        </div>
      </div>
    </Modal>
  );
}

export default EditStatus;
